<template>
  <div id="app">
    <AppSidebar @sidebar-toggle="sidebarCollapsed = $event" />
    <main :class="['main-content', { 'sidebar-collapsed': sidebarCollapsed }]">
      <router-view />
    </main>
    <footer id="footer" />
  </div>
</template>

<script>
import { computed } from 'vue'
import AppSidebar from './components/Sidebar.vue'
export default {
  name: 'App',
  components: { AppSidebar },
  provide() {
    return {

      currentUser: computed(() => this.currentUser)
    }
  },
  data() {
    return {
      sidebarCollapsed: false,
      currentUser: null
    }
  },
  created() {
    window.seezSdk.getCurrentUser().then(r => {this.currentUser = r ? { ...r } : null})  
  },

  mounted() {
    window.seezSdk?.userSubscribe?.(user => {
      this.currentUser = user ? { ...user } : null
    })
  },
  
  methods: {
    async userClick() {
      if (this.currentUser) {
        window.seezSdk.showLogout()
      } else {
        window.seezSdk.showLogin()
      }
    }
  }
}
</script>

<style>
@import './assets/minimal-theme.css';

#app {
  min-height: 100vh;
  background: var(--color-bg);
  font-family: 'Manrope', sans-serif;
  overflow: hidden;
}

.main-content {
  margin: 0 auto;
  padding: 1.5em 2.5em 2em 2.5em;
  margin-left: 180px;
  font-size: 15px;
  line-height: 1.5;
  transition: margin-left 0.18s cubic-bezier(0.4, 0, 0.2, 1);
  height: 100%;
  overflow: auto;
}
.main-content.sidebar-collapsed {
  margin-left: 56px;
}

body,
html {
  font-family: 'Manrope', sans-serif;
  font-size: 15px;
  line-height: 1.5;
  background: var(--color-bg);
  color: var(--color-text);
}
</style>
